export const CollectionListStatus = {
  Private: '0',
  Public: '1',
  PublicWaiting: '2', // DB上では管理しない値
  PublicEnd: '3', // DB上では管理しない値
  All: null // DB上では管理しない値
}
export type CollectionListStatus = typeof CollectionListStatus[keyof typeof CollectionListStatus]
